import { H1, H3 } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";

const styles = {
	container: css({ widht: "100%" }),
	subtitle: css({ marginTop: "10px !important" }),
};

interface Props {
	dark: boolean;
}

const About: React.FC<Props> = ({ dark: boolean }) => {
	return (
		<div {...styles.container}>
			<H1>About SYPT Fight-Manager</H1>
			The SYPT Fight-Manager is a tool developed by Marc Bitterli over the last 1.5 Years to help
			with the processes behind the scenes of all future SYPTs. It combines the old Fight Clock and
			aims to replace all paper/excel based recording of grades and manual work as well as automatic
			(live) publication of the ranking.
			<H3 {...styles.subtitle}>Disclaimer</H3>
			The Fight-Manager is still work-in-progress and bugs and problems might occur. In 2019, we
			only use it in addition to all old methods and the ranking published on www.sypt.ch will be
			the official and final version. Any deviations on this website should be reported to
			<a href="mailto:marc.bitterli@synt.ch"> Marc Bitterli</a>.
			<H3 {...styles.subtitle}>Feedback</H3>
			We greatly appreciate any Feedback and Bug reports. Please send them to
			<a href="mailto:marc.bitterli@synt.ch"> Marc Bitterli</a>.
		</div>
	);
};

export default About;



// WEBPACK FOOTER //
// ./src/Public/About.tsx